// removed by extract-text-webpack-plugin
module.exports = {"Card":"_2nCUgm0i9ES6K2Y-omJj43","Pagination":"_2OhS6AaNNDxWn1IzWpnefS","ActiveLink":"_2IpR3Yf5uKD-FN5jF8NB67","Header":"_1Awztk1n8ulvKETjOEKHHp","Title":"_38YsSreKECFZ0BQ3nSBGeC","IconLeft":"_2lUjrv8gZMZW96ryiQ1xPB","Btn":"_2XO8raibi8AE6X5JYH1GhC","inputWrap":"TWV6ddeQuQY_URTd6UoMl"};


//////////////////
// WEBPACK FOOTER
// ./src/PagesOfAdministrator/Accounts/styles.module.css
// module id = 603
// module chunks = 0